<script setup>
import {
  defineProps,
  computed,
  onBeforeMount,
  onUnmounted,
  ref,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import GameItem from "./GameItem.vue";

const props = defineProps({
  id: String,
  title: String,
  subTitle: String,
  listName: String,
  type: Number,
});

const store = useStore();
const { t, locale } = useI18n();
const { proxy } = getCurrentInstance();
const swal = proxy.$swal

const list = computed(() => {
  return store.state[props.listName] || [];
});

const onClickItem = (item) => {
  console.log("onClickItem", store.state.loggedIn, item);
  if (!store.state.loggedIn) {
    swal.error({
      title: t('common.loginRequired'),
    });
  } else if (item.maintenance) {
    swal.error({
      title: t('gameList.underMaintenance'),
    });
  } else {
    if (props.listName.startsWith("slot")) {
      store.dispatch("showSlotGamePopup", {
        open: true,
        lang: locale.value,
        gameInfo: item,
      });
    } else {
      store.dispatch("getGameProcess", {
        lang: locale.value,
        gameInfo: item,
      });
    }
  }
};

const MIN_LIST = 18;
const maxList = ref(MIN_LIST);
const isSmallScreen = ref(false);
const backgroundImage =
  props.id === "casino-section"
    ? `url('/assets/img/background/bg-1.png')`
    : props.id === "slot-section"
      ? `url('/assets/img/background/bg-2.png')`
      : `url('/assets/img/background/bg-2.png')`;

const onClickMore = () => {
  if (maxList.value === MIN_LIST) {
    maxList.value = list.value.length;
  } else {
    maxList.value = MIN_LIST;
  }
};

function handleMediaQueryChange(event) {
  isSmallScreen.value = event.matches;
}

onBeforeMount(() => {
  const mediaQuery = window.matchMedia("(max-width: 768px)");
  mediaQuery.addEventListener("change", handleMediaQueryChange);
  handleMediaQueryChange(mediaQuery);
});

onUnmounted(() => {
  const mediaQuery = window.matchMedia("(max-width: 768px)");
  mediaQuery.removeEventListener("change", handleMediaQueryChange);
});
</script>

<template>
  <section
    class="wptb-service-one z-index-2 bg-image-2 position-relative p-0 pt-5"
    :style="{ backgroundImage }"
    :id="id"
  >
    <div class="wptb-item-layer wptb-item-layer-four slide-top-to-bottom">
      <img src="/assets/img/more/object4.png" alt="img" />
    </div>
    <div class="container">
      <div class="wptb-heading">
        <div class="wptb-item--inner">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <h6 class="wptb-item--subtitle">{{ subTitle }}</h6>
              <h1 class="wptb-item--title">
                {{ title }}
                <span>
                  <button
                    v-if="!isSmallScreen"
                    class="underline text-lg"
                    @click="onClickMore"
                  >
                    {{ $t('gameList.showAll') }}
                  </button>
                </span>
              </h1>
              <div class="wptb-item--divider"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="scrollable-container" v-if="isSmallScreen"
        :style="{ gridTemplateColumns: `repeat(${Math.round(list.length/2)}, 1fr)` }"
      >
        <GameItem
          v-for="(item, index) in list.slice(0, list.length)"
          :key="index"
          :item="item"
          :onClick="onClickItem"
        />
      </div>
      <div class="row" v-else>
        <GameItem
          v-for="(item, index) in isSmallScreen ? list : list.slice(0, maxList)"
          :key="index"
          :item="item"
          :onClick="onClickItem"
        />
      </div>
    </div>
  </section>
</template>

<style>
.btn-three .btn-wrap {
  font-weight: 800;
  color: white;
}

.btn-three .btn-wrap:hover {
  color: red;
}

.scrollable-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr); /* 한 줄에 7개 아이템 */
  grid-template-rows: repeat(2, auto); /* 두 줄로 제한 */
  gap: 10px;
  overflow-x: auto; /* 가로 스크롤은 유지 */
  overflow-y: hidden; /* 세로 스크롤은 숨김 */
  padding: 10px 0;
}

.scrollable-container .item {
  min-width: 150px; /* 요청대로 150px로 변경 */
  max-width: 150px; /* 요청대로 150px로 변경 */
  margin: 0 auto; /* 중앙 정렬 */
}
.scrollable-container .item > div  {
  width: 150px; /* 요청대로 150px로 변경 */
}

.row .item {
  display: inline-block;
  max-width: 200px;
}

.grayscale {
  pointer-events: none; /* 유지보수 중인 게임은 클릭 비활성화 */
}

@media (max-width: 768px) {
}
</style>
